import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { MAR_CHART_QUERY_KEY, MAR_CHART_URL } from './queryConstants'

type UseMarChartProps = {
  residentId: string
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
  enabled?: boolean
}

type UseMarChartReturn = {
  data: any
  isLoading: boolean
  refetch: () => void
}

export const useMarChart = ({
  residentId,
  startDate,
  endDate,
  enabled = true
}: UseMarChartProps): UseMarChartReturn => {
  const formattedStartDate =
    startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format('YYYY-MM-DD')
      : ''
  const formattedEndDate =
    endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format('YYYY-MM-DD')
      : ''

  const params = getQueryParams({
    residentId,
    startDate: formattedStartDate,
    endDate: formattedEndDate
  })

  const { data, isLoading, refetch } = useQuery(
    [MAR_CHART_QUERY_KEY, residentId, formattedStartDate, formattedEndDate],
    () =>
      getJSON({
        url: `${MAR_CHART_URL}?${params}`
      }),
    {
      enabled:
        enabled &&
        Boolean(
          residentId &&
            startDate &&
            endDate &&
            formattedStartDate &&
            formattedEndDate
        ),
      retry: 1
    }
  )

  return {
    data: data || null,
    isLoading,
    refetch
  }
}

export default useMarChart
